<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		url: string;
		external: boolean;
		wrapperClass?: string;
		children: Snippet;
		class?: string;
	}

	let { url, external, wrapperClass, children, class: className }: Props = $props();

	let scaleOrigin = $state('origin-left');
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class={['group flex flex-col', wrapperClass]}
	onmouseenter={() => (scaleOrigin = 'origin-left')}
	onmouseleave={() => (scaleOrigin = 'origin-right')}
>
	<a
		href={url}
		target={external ? '_blank' : null}
		rel={external ? 'noopener noreferrer' : null}
		class={className}
	>
		{@render children()}
	</a>
	<div
		class={[
			'h-[2px] w-full translate-y-0.5 scale-0 transform-gpu bg-brown-2 transition-transform duration-400 ease-in-out group-hover:scale-100 max-sm:hidden',
			scaleOrigin
		]}
		ontransitionend={() => (scaleOrigin = 'origin-left')}
	></div>
</div>
